import { combineReducers } from 'redux';
import { cartItems, discount, masterPaid, orderId, paid, transactionList } from './billManagementReducer';
import { diseaseList } from './clinicalInfoReducer';
import { isShowBackDrop } from './commonReducers';
import { birthOfYear, isNewPatient, loadPatientDetails, patientId } from './patientDetailsReducer';


const rootReducer = combineReducers({
    cartItems, birthOfYear, diseaseList, patientId, orderId, loadPatientDetails,
    isNewPatient, paid, discount, transactionList, masterPaid, isShowBackDrop
});

export default rootReducer; 